import { Component } from '@angular/core';

@Component({
  selector: 'app-connections',
  template: `<connections-list></connections-list>`,
})
export class ConnectionsComponent {}
